module.exports = __webpack_public_path__ + "img/hover_icon_public_portal_maintenance.59785118.svg";